// Academy Comments — i18n strings (ES / EN / SK).
// Same shape as /app/frontend/src/i18n/academy-tools.js — pick with `tx(key, lang)`.

const ES = {
  titulo: "Comentarios de la Comunidad",
  subtitulo: "Comparte tu experiencia con la Academia RE₿EL",
  placeholder: "¿Qué te parece la academia? Comparte tu experiencia...",
  botonPublicar: "PUBLICAR COMENTARIO",
  sinCuenta: "Inicia sesión para dejar un comentario",
  loginBtn: "Iniciar sesión →",
  registroBtn: "Crear cuenta gratis →",
  sinComentarios: "Sé el primero en comentar la academia",
  borrar: "Borrar",
  confirmarBorrar: "¿Eliminar este comentario?",
  comentarioBorrado: "Comentario eliminado",
  caracteresRestantes: "caracteres restantes",
  errorVacio: "El comentario no puede estar vacío",
  errorLargo: "Máximo 500 caracteres",
  publicando: "Publicando...",
  publicado: "✓ Comentario publicado",
  verMas: "Ver más comentarios",
  adminBadge: "ADMIN",
  proBadge: "PRO",
  spamError: "Máximo 3 comentarios por hora",
  errorConexion: "Error de conexión. Inténtalo de nuevo.",
  ahora: "ahora",
  min: "min",
  h: "h",
  d: "d",
  meses: "meses",
};

const EN = {
  titulo: "Community Comments",
  subtitulo: "Share your experience with RE₿EL Academy",
  placeholder: "What do you think about the academy? Share your experience...",
  botonPublicar: "POST COMMENT",
  sinCuenta: "Sign in to leave a comment",
  loginBtn: "Sign in →",
  registroBtn: "Create free account →",
  sinComentarios: "Be the first to comment on the academy",
  borrar: "Delete",
  confirmarBorrar: "Delete this comment?",
  comentarioBorrado: "Comment deleted",
  caracteresRestantes: "characters remaining",
  errorVacio: "Comment cannot be empty",
  errorLargo: "Maximum 500 characters",
  publicando: "Posting...",
  publicado: "✓ Comment posted",
  verMas: "Load more comments",
  adminBadge: "ADMIN",
  proBadge: "PRO",
  spamError: "Maximum 3 comments per hour",
  errorConexion: "Connection error. Please try again.",
  ahora: "just now",
  min: "min",
  h: "h",
  d: "d",
  meses: "mo",
};

const SK = {
  titulo: "Komentáre komunity",
  subtitulo: "Podeľte sa o svoju skúsenosť s Akadémiou RE₿EL",
  placeholder: "Čo si myslíte o akadémii? Podeľte sa o svoju skúsenosť...",
  botonPublicar: "PRIDAŤ KOMENTÁR",
  sinCuenta: "Prihláste sa a napíšte komentár",
  loginBtn: "Prihlásiť sa →",
  registroBtn: "Vytvoriť bezplatný účet →",
  sinComentarios: "Buďte prvý, kto okomentuje akadémiu",
  borrar: "Vymazať",
  confirmarBorrar: "Vymazať tento komentár?",
  comentarioBorrado: "Komentár vymazaný",
  caracteresRestantes: "zostávajúcich znakov",
  errorVacio: "Komentár nemôže byť prázdny",
  errorLargo: "Maximálne 500 znakov",
  publicando: "Zverejňuje sa...",
  publicado: "✓ Komentár zverejnený",
  verMas: "Načítať ďalšie komentáre",
  adminBadge: "ADMIN",
  proBadge: "PRO",
  spamError: "Maximálne 3 komentáre za hodinu",
  errorConexion: "Chyba pripojenia. Skúste to znova.",
  ahora: "práve teraz",
  min: "min",
  h: "h",
  d: "d",
  meses: "mesiacov",
};

const DE = {
  titulo: "Community-Kommentare",
  subtitulo: "Teile deine Erfahrung mit der RE₿EL Academy",
  placeholder: "Wie findest du die Academy? Teile deine Erfahrung...",
  botonPublicar: "KOMMENTAR VERÖFFENTLICHEN",
  sinCuenta: "Melde dich an, um einen Kommentar zu hinterlassen",
  loginBtn: "Anmelden →",
  registroBtn: "Kostenloses Konto erstellen →",
  sinComentarios: "Sei der Erste, der die Academy kommentiert",
  borrar: "Löschen",
  confirmarBorrar: "Diesen Kommentar löschen?",
  comentarioBorrado: "Kommentar gelöscht",
  caracteresRestantes: "Zeichen verbleibend",
  errorVacio: "Der Kommentar darf nicht leer sein",
  errorLargo: "Maximal 500 Zeichen",
  publicando: "Wird veröffentlicht...",
  publicado: "✓ Kommentar veröffentlicht",
  verMas: "Mehr Kommentare anzeigen",
  adminBadge: "ADMIN",
  proBadge: "PRO",
  spamError: "Maximal 3 Kommentare pro Stunde",
  errorConexion: "Verbindungsfehler. Bitte erneut versuchen.",
  ahora: "jetzt",
  min: "Min",
  h: "Std",
  d: "T",
  meses: "Monate",
};

const ZH_CN = {
  titulo: "社区评论",
  subtitulo: "分享您在 RE₿EL 学院的体验",
  placeholder: "您觉得学院怎么样？分享您的体验...",
  botonPublicar: "发布评论",
  sinCuenta: "登录后发表评论",
  loginBtn: "登录 →",
  registroBtn: "免费创建账户 →",
  sinComentarios: "成为第一个评论学院的人",
  borrar: "删除",
  confirmarBorrar: "删除此评论？",
  comentarioBorrado: "评论已删除",
  caracteresRestantes: "剩余字符",
  errorVacio: "评论不能为空",
  errorLargo: "最多 500 个字符",
  publicando: "发布中...",
  publicado: "✓ 评论已发布",
  verMas: "查看更多评论",
  adminBadge: "ADMIN",
  proBadge: "PRO",
  spamError: "每小时最多 3 条评论",
  errorConexion: "连接错误，请重试。",
  ahora: "刚刚",
  min: "分钟",
  h: "小时",
  d: "天",
  meses: "月",
};

const ALL = { es: ES, en: EN, sk: SK, de: DE, "zh-CN": ZH_CN };

export const getComentariosI18n = (lang) => ALL[lang] || ALL.es;

// Pluralization helper — Spanish/English are simple; Slovak uses
// the 1 / 2-4 / 5+ rule (komentár / komentáre / komentárov).
export const totalComentariosLabel = (n, lang) => {
  if (lang === "en") return n === 1 ? "1 comment" : `${n} comments`;
  if (lang === "sk") {
    if (n === 1) return "1 komentár";
    if (n >= 2 && n <= 4) return `${n} komentáre`;
    return `${n} komentárov`;
  }
  return n === 1 ? "1 comentario" : `${n} comentarios`;
};

// Translate API error codes into a localized message.
export const translateError = (code, lang) => {
  const T = getComentariosI18n(lang);
  const map = {
    unauthorized: T.sinCuenta,
    empty: T.errorVacio,
    too_long: T.errorLargo,
    spam: T.spamError,
  };
  return map[code] || T.errorConexion;
};

// Relative time formatter using the locale-specific short tokens.
export const tiempoRelativo = (isoDate, lang) => {
  const T = getComentariosI18n(lang);
  const ts = new Date(isoDate).getTime();
  if (!ts) return T.ahora;
  const diff = Date.now() - ts;
  const mins = Math.floor(diff / 60_000);
  const hours = Math.floor(diff / 3_600_000);
  const days = Math.floor(diff / 86_400_000);
  const months = Math.floor(diff / 2_592_000_000);
  if (mins < 1) return T.ahora;
  if (mins < 60) return `${mins}${T.min}`;
  if (hours < 24) return `${hours}${T.h}`;
  if (days < 30) return `${days}${T.d}`;
  return `${months} ${T.meses}`;
};
